const GetAllLeadPartyRequest = function () {
  return {
    "processId": "",
    "variables": []
  }
};

export default GetAllLeadPartyRequest;



// WEBPACK FOOTER //
// ./src/service/request/GetMyActiveTaskRequest.js